import { CurvaAbcVendaFilter } from '../../filter';
import { CurvaAbcVendaPerspectiva } from '../../perspectiva';

export class CurvaAbcVendaExcelExportModal {
    nomeExportacao: string;
    perspectiva: CurvaAbcVendaPerspectiva;
    filter: CurvaAbcVendaFilter;
    orderBy: number;
    orderByDir: string;

    constructor(perspectiva: CurvaAbcVendaPerspectiva, filter: CurvaAbcVendaFilter, orderBy: number, orderByDir: string) {
        this.perspectiva = perspectiva,
        this.filter = filter;
        this.orderBy = orderBy;
        this.orderByDir = orderByDir;
    }
}
